// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuSeparator_wrapper__K6uQW","line":"MenuSeparator_line__qzb6U"};